/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import RCCheckbox from 'rc-checkbox';
import { areEqualFields, scrollToNextMatchingSibling } from 'utils/form';
import isNil from 'lodash/isNil';
import cn from 'classnames';
import 'rc-checkbox/assets/index.css';
import s from './Checkbox.module.scss';

const Checkbox = ({
  field: { name, value, onBlur },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  icon = null,
  color = 'black',
  skipScrollingToField,
  sideEffectOnChange,
  skipScrollingOnChange,
  ...props
}) => {
  const { label, className, description } = props;
  const fieldWrapperRef = useRef();

  const handleChange = useCallback(
    (e) => {
      const v = e.target.checked;
      setFieldValue(name, v);
      if (typeof sideEffectOnChange === 'function') sideEffectOnChange(v);
      if (v && !skipScrollingOnChange) scrollToNextMatchingSibling(fieldWrapperRef);
    },
    [name, setFieldValue, sideEffectOnChange, skipScrollingOnChange],
  );

  useEffect(() => {
    if (isNil(value)) setFieldValue(name, false);
  }, [name, setFieldValue, value]);

  const fieldWrapperClassnames = useMemo(() => {
    let classes = '';
    if (!skipScrollingToField) {
      classes += 'scroll-to-field';
    }
    return cn(s.checkboxWrapper, className, classes);
  }, [skipScrollingToField, className]);

  return (
    <div className={fieldWrapperClassnames} ref={fieldWrapperRef}>
      <div className={s.checkboxContent}>
        <RCCheckbox
          name={name}
          id={name}
          type="checkbox"
          value={value || false}
          checked={value}
          onChange={handleChange}
          onBlur={onBlur}
          className={s.checkboxInput}
        />
        <label className={s.label} htmlFor={name}>
          <div style={{ color }}>{label}</div>
          {icon ? <div className={s.icon}>{icon}</div> : null}
        </label>
      </div>

      {description ? (
        <div className={s.note}>
          <small className="muted">{description}</small>
        </div>
      ) : null}
      {errors[name] && touched[name] && <div className="error-text">{errors[name]}</div>}
    </div>
  );
};

export default memo(Checkbox, areEqualFields);
